import styled from 'styled-components';
import { Row, Column, constants } from '@narvar/nth-grid';

const smallBreakpoint = constants.breakpointMinWidths[constants.WIDTH_SM];

export const ActionsRow = styled(Row)`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 0;
  @media (min-width: ${smallBreakpoint}) {
    flex-direction: row;
    margin-top: 1.5rem;
  }
`;

export const ChangeLocationWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: 0;
    margin-left: 0.5rem;
    justify-content: flex-start;
  }
`;

export const FedexAttributionWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  @media (min-width: ${smallBreakpoint}) {
    justify-content: flex-end;
    margin-top: 0;
  }
`;

export const LocationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 1.5rem 0;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 3.5rem;
  height: 3.5rem;
`;
